import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { makeBackendApi } from '../BackendApi';
import { IPage } from '../types';
import { IBackendUser } from '../types/Users';

interface IUseBEUsersOptions {
  sort?: string;
  page?: IPage;
}

export const useBackendUsers = (filterTerm: string, options?: IUseBEUsersOptions) => {
  const backendApi = makeBackendApi();

  const beUsers = useQuery<AxiosResponse<{ data: IBackendUser[] }>>({
    queryKey: ['be-users', filterTerm],
    queryFn: () =>
      backendApi.searchUsersSimple(filterTerm, options?.sort ?? 'firstName', options?.page),
  });

  return beUsers;
}
